module.exports = __webpack_public_path__ + "media/images/vp/icon.checkbox.on.red-ce9bea99b80564fb8decac847fbcf2a4.svg";